import { Spinner } from "@/components/Spinner";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { auth } from "@/lib/firebase";
import { useAuth, UserProfile } from "@clerk/clerk-react";
import { createFileRoute } from "@tanstack/react-router";
import { signOut } from "firebase/auth";
import { LogOutIcon } from "lucide-react";

export const Route = createFileRoute("/dashboard/profile")({
  component: () => {
    const { isLoaded, signOut: clerkSignOut } = useAuth();
    const navigate = Route.useNavigate();
    const logoutHandler = async () => {
      await clerkSignOut();
      await signOut(auth);
      navigate({ to: "/login" });
    };
    if (!isLoaded) return <Spinner />;
    return (
      <div className="flex h-screen w-full flex-col items-center justify-center">
        <UserProfile routing="hash">
          <UserProfile.Page
            label="Log Out"
            labelIcon={<LogOutIcon className="size-4" />}
            url="/logout"
          >
            <div className="flex h-48 flex-col items-center justify-center gap-4 p-6">
              <Label className="text-2xl">
                Are you sure you want to log out?
              </Label>
              <div className="flex gap-4">
                <Button
                  className="light"
                  variant="destructive"
                  onClick={logoutHandler}
                >
                  Log Out
                </Button>
                <a href="#">
                  <Button className="light" variant="outline">
                    Cancel
                  </Button>
                </a>
              </div>
            </div>
          </UserProfile.Page>
        </UserProfile>
      </div>
    );
  },
});
